(function () {
  function parseTabs(root) {
    var script = root.querySelector('script[data-spec-tabs]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function applyTab(root, tabs, index) {
    var tab = tabs[index];
    if (!tab) return;

    root.querySelectorAll('[data-spec-tab-button]').forEach(function (button) {
      var isActive = Number(button.getAttribute('data-spec-tab-button')) === index;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    Object.keys(tab.metrics || {}).forEach(function (metricKey) {
      var metric = tab.metrics[metricKey];
      var value = metric.value || '';
      var sublabel = metric.sublabel || '';
      var detailText = sublabel ? value + ' (' + sublabel + ')' : value;

      root.querySelectorAll('[data-metric="' + metricKey + '"][data-field="value"]').forEach(function (el) {
        el.textContent = value;
      });
      root.querySelectorAll('[data-metric="' + metricKey + '"][data-field="sublabel"]').forEach(function (el) {
        el.textContent = sublabel;
      });
      root.querySelectorAll('[data-metric="' + metricKey + '"][data-field="detail-text"]').forEach(function (el) {
        el.textContent = detailText;
      });
      root.querySelectorAll('[data-metric="' + metricKey + '"][data-field="bar"]').forEach(function (el) {
        el.style.width = (metric.percent || 0) + '%';
      });
    });

    root.querySelectorAll('[data-field="product-weight"]').forEach(function (el) {
      el.textContent = tab.productWeight || '';
    });
    root.querySelectorAll('[data-field="package-weight"]').forEach(function (el) {
      el.textContent = tab.packageWeight || '';
    });
  }

  function findMatchingTabIndex(tabs, variantText) {
    if (!variantText) return -1;
    for (var i = 0; i < tabs.length; i++) {
      if (tabs[i].match && variantText.indexOf(tabs[i].match) !== -1) {
        return i;
      }
    }
    return -1;
  }

  // Native <details> only reveals its content when the `open` attribute is
  // actually present - CSS alone can't force it open. On desktop every group
  // (except "Key differences") should always be expanded; on mobile only the
  // groups flagged with [data-default-open] start expanded.
  function applyResponsiveGroups(root) {
    var isDesktop = window.innerWidth >= 769;
    root.querySelectorAll('.m-spec-compare__group').forEach(function (details) {
      if (details.classList.contains('m-spec-compare__group--keydiff')) return;
      details.open = isDesktop || details.hasAttribute('data-default-open');
    });
  }

  function init(root) {
    var tabs = parseTabs(root);
    if (!tabs.length) return;

    applyResponsiveGroups(root);
    window.addEventListener('resize', function () {
      applyResponsiveGroups(root);
    });

    root.querySelectorAll('[data-spec-tab-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        applyTab(root, tabs, Number(button.getAttribute('data-spec-tab-button')));
      });
    });

    if (root.getAttribute('data-sync-variant') === 'true') {
      document.addEventListener('variant:changed', function (event) {
        var variant = event.detail && event.detail.variant;
        if (!variant) return;
        var variantText = [variant.title, variant.option1, variant.option2, variant.option3]
          .filter(Boolean)
          .join(' ');
        var matchIndex = findMatchingTabIndex(tabs, variantText);
        if (matchIndex !== -1) applyTab(root, tabs, matchIndex);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-spec-compare]').forEach(init);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', initAll)
    : initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
